import { render, staticRenderFns } from "./PedidoRetirada.vue?vue&type=template&id=8b4c7898"
import script from "./PedidoRetirada.vue?vue&type=script&lang=js"
export * from "./PedidoRetirada.vue?vue&type=script&lang=js"
import style0 from "./PedidoRetirada.vue?vue&type=style&index=0&id=8b4c7898&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports